<template>
  <modal width="560px" :title="t('Check your 2-step verification settings')" @close="close">
    <template #default>
      <div class="d-flex error-block mt-8">
        {{ t('Please assure your 2-step verification settings are up to date.') }}
      </div>

      <div class="mt-16">
        <div>{{ t('Each of ten backup codes can be used once.') }}</div>
        <div>{{ t('After all the codes are introduced, the access to the panel will be blocked.') }}</div>
        <div>{{ t('Make sure you use the codes wisely.') }}</div>
        <div>{{ t('It is recommended to use codes from the app each time you log in to the panel.') }}</div>
      </div>
    </template>

    <template #footer>
      <section class="justify-end xs12" style="display: flex">
        <ui-button @click="close" :text="t('Ok')"></ui-button>
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';

type TwoFactorBackupCodeDialogData = {
  onClose?: () => void;
};

const props = withDefaults(
  defineProps<{
    data?: TwoFactorBackupCodeDialogData;
  }>(),
  {
    data: () => ({}),
  },
);

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

const close = () => {
  emit('close');
  props.data.onClose?.();
};
</script>

<style lang="scss">
</style>
